import React from 'react';
import { connect } from 'react-redux';
import { handleAPIProvidedErrorMessage } from '../../../misc/handleAPIProvidedErrorMessage';
import Button from '../../elements/Button/Button';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Input from '../../elements/forms/Input';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';

class MyProfileScreen_Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: props.user.first_name || '',
            lastName: props.user.last_name || '',
            position: props.user.position || '',
            company: props.user.company || '',
            description: props.user.description || '',
        };
    }
    render() {
        var { i18n, user } = this.props,
            header = (
                <>
                    <TopBar returnURL=".."></TopBar>
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <LeftTabbedGrayHeader>
                            {i18n['label.edit.profile']}
                        </LeftTabbedGrayHeader>
                        <br />
                        <br />
                        <div className="indent content">
                            <Input
                                value={this.state.firstName}
                                label={i18n['label.editprofile.firstname']}
                                onChange={this.handleChange.bind(
                                    this,
                                    'firstName'
                                )}
                            />
                            <Input
                                value={this.state.lastName}
                                label={i18n['label.editprofile.surname']}
                                onChange={this.handleChange.bind(
                                    this,
                                    'lastName'
                                )}
                            />
                            <Input
                                value={this.state.position}
                                label={i18n['label.editprofile.function']}
                                onChange={this.handleChange.bind(
                                    this,
                                    'position'
                                )}
                            />
                            <Input
                                value={this.state.company}
                                label={i18n['label.editprofile.business']}
                                onChange={this.handleChange.bind(
                                    this,
                                    'company'
                                )}
                            />
                            <Input
                                type="textarea"
                                value={this.state.description}
                                label={i18n['label.editprofile.mybiography']}
                                onChange={this.handleChange.bind(
                                    this,
                                    'description'
                                )}
                            />
                            <br />
                        </div>
                        <div className="content">
                            <Button type="submit" primary  >
                                {i18n['label.editprofile.store']}
                            </Button>
                        </div>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({ [field]: value });
    }
    handleSubmit(e) {
        e.stopPropagation();
        e.preventDefault();

        app.api.users
            .updateUserProfile(this.props.user.id, {
                first_name: this.state.firstName.trim(),
                last_name: this.state.lastName.trim(),
                position: this.state.position.trim(),
                company: this.state.company.trim(),
                description: this.state.description.trim(),
            })
            .then(
                async function (user) {
                    await dialogAlert(
                        this.props.i18n['msg.message.upload.profile']
                    );
                    app.history.push('..');
                }.bind(this)
            )
            .catch(handleAPIProvidedErrorMessage);
    }
}

export default connect(function (state, props) {
    return {
        i18n: state.i18n.translations,
        user: state.session.user,
    };
})(MyProfileScreen_Edit);
